module.exports = __webpack_public_path__ + "static/media/stb.fae4a0a7.webp";